export type NotificationType =
  | "trade"
  | "system"
  | "performance"
  | "market"
  | "learning"
  | "announcement"
  | "billing"
  | "statistics"
  | "marketing"
  | "reports";

export interface NotificationModel {
  id: string;
  type: NotificationType;
  title: string;
  /** HTML string (already formatted) */
  message: string;
  time: string;
  avatarName: string;
  avatarSrc: string;
  isRead: boolean;
  /** Backend notification event key (e.g. performance.summary.daily). */
  eventKey?: string | null;
  /** Structured payload used in detail view and performance summary grids */
  details?: Record<string, unknown> | null;
}

export function getNotificationIcon(type: string): string {
  switch (type) {
    case "trade":
      return "💰";
    case "system":
      return "⚠️";
    case "performance":
      return "🎯";
    case "market":
      return "📈";
    case "learning":
      return "📚";
    default:
      return "🔔";
  }
}

export function getNotificationColor(type: string): string {
  switch (type) {
    case "trade":
      return "green";
    case "system":
      return "orange";
    case "performance":
      return "purple";
    case "market":
      return "cyan";
    case "learning":
      return "blue";
    default:
      return "gray";
  }
}

